import { render, staticRenderFns } from "./leftmenu.vue?vue&type=template&id=6e5a1162&"
import script from "./leftmenu.vue?vue&type=script&lang=js&"
export * from "./leftmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports